import { SystemUser } from '@hkm/shared/entities/SystemUser';
import { Store } from '@hkm/store/interfaces/store';

import { UserDetails } from '@ac/library-api';

export const selectSystemUser = (state: Store): SystemUser | null =>
  state.userContext.systemUser;
export const selectUserDetails = (state: Store): UserDetails | null =>
  state.userContext.userDetails;



// WEBPACK FOOTER //
// ./src/components/Login/domain/selectors.ts